<template>
    <ProfileBase>
        <FormPassword :wide="true" />
    </ProfileBase>
</template>
<script>
    import ProfileBase from "./ProfileBase.vue";
    import FormPassword from "@/components/form/FormPassword.vue";

    export default {
        name: "Password",
        components: {
            ProfileBase,
            FormPassword
        }
    };
</script>
